import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvestmentListComponent } from './investment-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvestmentService } from '../investment.service';

@Component({
    selector: 'convfact-investmentdelete',
    templateUrl: './investment-dialog-delete.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})
export class InvestmentDialogDeleteComponent {
  uid: string = this.data.uid;
  type: string = this.data.type;
  response_message: string;
  response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<InvestmentListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public investmentService: InvestmentService
  ) { }

  delete() {
    this.investmentService.deleteData(this.uid)
      .then(res => {
        this.response_message = res.message;
        this.response_error = res.error;
      }).catch(err => {
        this.response_message = err.error.message;
        this.response_error = err.error.error;
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
